import React from "react";
import {
  FaGem,
  FaCut,
  FaCheckCircle,
  FaShieldAlt,
  FaGlobe,
} from "react-icons/fa"; // Importing from react-icons/fa
import "./ManufacturingProcess.css"; // Import the CSS file

export default function ManufacturingProcess() {
  const steps = [
    {
      title: "Sourcing",
      description:
        "Ethically sourced rough diamonds from trusted mines worldwide.",
      icon: FaGem,
    },
    {
      title: "Cutting",
      description:
        "Precision cutting using advanced technology for maximum brilliance.",
      icon: FaCut,
    },
    {
      title: "Polishing",
      description: "Expert artisans refine every facet to perfection.",
      icon: FaCheckCircle,
    },
    {
      title: "Grading & Certification",
      description:
        "Strict quality checks ensure industry-standard certification.",
      icon: FaShieldAlt,
    },
    {
      title: "Global Distribution",
      description: "Securely shipped to clients across the world.",
      icon: FaGlobe,
    },
  ];

  return (
    <section className="manufacturing1-process">
      <div className="containe2r">
        <h2 className="title2">Our Manufacturing Process</h2>
        <div className="step1s-grid">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="step1-item">
                <Icon className="icon1" />
                <p className="step1-title">{step.title}</p>
                <p className="step1-description">{step.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
